import { removeUser } from '../utility/sessionStorage';
import { User } from './User.types';

export const logout = (user: User) => {
    if (user) {
        removeUser();
    }

    window.location.reload();
};
